import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
});

function handleSwiperInit() {
    const blocks = document.querySelectorAll('.recommended-products-block');

    blocks.forEach(block => {
        const container = block.querySelector('.swiper');
        if (!container) return;

        const swiper = new Swiper(container, {
            modules: [Navigation, Pagination],
            spaceBetween: '16px',
            slidesPerView: 1,
            navigation: {
                nextEl: block.querySelector('.swiper-button-next'),
                prevEl: block.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: block.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
            },
        });

        swiper;
    });
}

